import { Flex, ModuleLayout, Space, Spacing } from '@billy/design-system'
import React from 'react'

import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { useVatDeclaration } from '../../../../context/vatDeclarationContext'
import { useVatDeclarationsRoutes } from '../../../../context/vatDeclarationsRouteContext'
import { InfoBox } from '../../../InfoBox'
import { VatDeclarationsLoadingView } from '../../../VatDeclarationsLoadingView'
import { VatDeclarationReport } from '../VatDeclarationReport'
import { VatDeclarationSideActions } from '../VatDeclarationSideActions'
import { VatDeclarationStatusCard } from '../VatDeclarationStatusCard'
import * as Styled from './styles'

export const VatDeclarationViewFR = () => {
  const { isLoading, vatDeclaration } = useVatDeclaration()
  const period = vatDeclaration?.periodText
  const vatDeclarationsRoutes = useVatDeclarationsRoutes()

  const { url: vatDeclarationsUrl } = useOrganizationViewUrl(vatDeclarationsRoutes.getMainRoute())

  if (isLoading || !vatDeclaration) {
    return <VatDeclarationsLoadingView />
  }

  return (
    <ModuleLayout
      backButtonTo={vatDeclarationsUrl}
      sideActions={<VatDeclarationSideActions />}
      title={period}
      withBackButton
    >
      <Flex gap={Spacing.S32}>
        <VatDeclarationReport />
        <Styled.StatusCardWrapper>
          <VatDeclarationStatusCard />
          <Space />
          <InfoBox />
        </Styled.StatusCardWrapper>
      </Flex>
    </ModuleLayout>
  )
}
